import { Injectable } from '@angular/core';
import { AppConstants } from "../app-constants";
import {Session} from "./session.service";
import {ActivatedRoute} from "@angular/router";
import {RoutesEnum} from "../enums/routes.enum";

@Injectable({
  providedIn: 'root'
})
export class GenericService {

  readonly projectStatuses = {
    internalReview: '{66FFB771-6D7F-484C-B566-637B3B29C43D}',
    externalReview: '{E97137A9-85AD-449B-9706-FB4F94C1CCAD}',
    assessmentCompleted: '{E97137A9-85AD-449B-9706-FB4F94C1CCAD}',
    accreditationCompleted: '{F1BEDF2D-833A-413B-BD94-CB1578CB374F}',
    notStarted: '{B4F49A53-2FD6-4535-AC4B-3578B9424286}',
    inProgress: '{208F1733-9990-4A42-B075-9CCF09C8E089}',
    //completed: '{f1bedf2d-833a-413b-bd94-cb1578cb374f}',
  };


  constructor(
    private session: Session,
  ) { }

  isDescendant(className:string , child) {
    let node = child.parentNode;
    while (node != null) {
      if ( typeof( node.classList ) != "undefined" && node.classList.contains(className)) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  getParam(param: string, route: ActivatedRoute): any {
    let val = route.snapshot.paramMap.get(param);
    if(!val){
      val = this.getQueryParams(param, route);
    }
    if(!val){
      val = this.getStateParam(param);
    }
    return val;
  }

  getQueryParams(param: string, route: ActivatedRoute): any {
    return route.snapshot.queryParamMap.get(param);
  }

  getStateParam(param: string): any {
    if (history.state && history.state[param]) {
      return history.state[param];
    }
    return '';
  }

  /*getProjectStatusName(statusRequestKey: string, isSubmitted:boolean = null) {
    if( isSubmitted === null ) { //assessment
      if(AppConstants.assessmentProjectStatusesByGuid[statusRequestKey]) {
        return AppConstants.assessmentProjectStatusesByGuid[ statusRequestKey ].name;
      }
    } else { //accreditation
      if( isSubmitted ) {
        return AppConstants.accreditationProgramStatuses.submitted.name;
      }

      switch ( statusRequestKey ) {
        /!*case AppConstants.accreditationProgramStatuses.readyForSubmission.guid:
          return AppConstants.accreditationProgramStatuses.readyForSubmission.name;

        case AppConstants.accreditationProgramStatuses.notStarted.guid:
          return AppConstants.accreditationProgramStatuses.notStarted.name;

        case AppConstants.accreditationProgramStatuses.internalReview.guid:
          return AppConstants.accreditationProgramStatuses.internalReview.name;

        case AppConstants.accreditationProgramStatuses.inProgress.guid:
          return AppConstants.accreditationProgramStatuses.inProgress.name;*!/

        default:
          return AppConstants.accreditationProgramStatuses.inProgress.name;

      }
    }
    return "";
  }*/

  validateEmail(email: string) {
    if(email){
      email = email.toLowerCase();
    }
    const emailRegex = RegExp("(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])");
    return ( email == "" || !emailRegex.test(email) );
  }

  getRouteParamsForProject(projectType: string, projectRequestKey: string):{routerLink: string[], queryParams: any} {
    if(projectType === AppConstants.assessmentWorkspaceRequestKey){
      return { routerLink: ['/assessment/workspace', projectRequestKey], queryParams: {}};
    }
    if(projectType === AppConstants.accreditationWorkspaceRequestKey){
      //if user belongs to an institution
      const user = this.session.getUser();
      if(user && !user.userOrganizationData.isAccreditor){
        return { routerLink: ['/accreditation/workspace', RoutesEnum.Institution, projectRequestKey], queryParams: {}};
      }
      else if(user && user.userOrganizationData.isAccreditor) {
        return {routerLink: ['/accreditation/workspace', RoutesEnum.Accreditor, projectRequestKey], queryParams: { }};
      }
    }

    return {routerLink: [], queryParams: {}};
  }

  capitalizeFirstCharacter(str: string) {
    if(str.length > 0 ) {
      return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
    } else {
      return str;
    }
  }

  /* Used in inputs, so they can accept only numbers, without looking like a number only input*/
  numberOnly(event: KeyboardEvent): void {
    // Prevent anything but numbers or delete and back from being entered.
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (!/[0-9]/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
